import React, { useEffect } from 'react';
import { ButtonGroup, Button, Col, DropdownButton, Row, Dropdown } from 'react-bootstrap';
import { ControlLabel, Form, FormControl, FormGroup, Input } from 'rsuite';
import PhoneNumberMask from '../../Shared/GenericComponents/PhoneNumberMask';
import { useState } from 'react';
import LoadingSpinner from '../../Shared/GenericComponents/LoadingSpinner';
import GenericSection from './Sections/GenericSection';
import summarySheetService from '../../../services/Internal/SummarySheet/summarySheet.service';
import Swal from 'sweetalert2';

function BaseSummarySheet(props) {
    const [model, setModel] = useState()
    const [sheetName, setSheetName] = useState();
    const [sheetTypeId, setSheetTypeId] = useState();
    const [hasLoaded, setHasLoaded] = useState(false)
    const [collapseSections, setCollapseSections] = useState(0)
    const [expandSections, setExpandSections] = useState(0)
    const [summaryTypes, setSummaryTypes] = useState([])
    useEffect(() => {
        summarySheetService.getSummaryTypes(props.appTypeId, props.parentTypeId).then((result) => {
            setSummaryTypes(result.data);
            summarySheetService.getSummarySheetTypeId(props.parentId, props.parentTypeId).then((sheetType) => {

                if (sheetType.data) {
                    setSheetTypeId(sheetType.data);
                    setSheetName(result.data.find(x => x.id == sheetType.data).code);
                    summarySheetService.getSummarySheet(props.parentId, props.parentTypeId, sheetType.data, props.entityId).then((response) => {
                        var data = response?.sections?.map((val, i) => {
                            return { ...val, entityId: props.entityId }
                        })
                        setModel({ ...response, sections: data })
                    });
                }
                setHasLoaded(true);
            })
        })
    }, [])

    useEffect(() => {
        if (props.saveSummarySheet) {
            if (model) {
                var dataToTransmit = {
                    ...model,
                    sections: model.sections.map(section => ({
                        ...section,
                        verifiedExperienceYears: section.verifiedExperienceYears == "" ? null : section.verifiedExperienceYears,
                        verifiedExperienceMonths: section.verifiedExperienceMonths == "" ? null : section.verifiedExperienceMonths,
                    }))
                }
                summarySheetService.updateEntireExamModel(dataToTransmit);
            }
        }
    }, [props.saveSummarySheet])

    useEffect(() => {
        //I'm so sorry
        //props.dowloadSummarySheet is used in tandum with the SummarySheetPdf.jsx file
        //When a user is trying to download a summary sheet we needed to save before they get the file and this was our solution
        //on init props.downloadSummarySheet is 0
        //when the user clicks the download button we increment that var
        //so on odd values we save the sheet, then once the save is done we increment again and the SummarySheetPdf.jsx will hook on to even values to download the pdf

        if (props.downloadSummarySheet != 0 && props.downloadSummarySheet % 2 == 1) {
            Swal.fire({
                title: 'Saving Summary',
                didOpen: () => {
                    Swal.showLoading();
                    if (model) {
                        var dataToTransmit = {
                            ...model,
                            sections: model.sections.map(section => ({
                                ...section,
                                verifiedExperienceYears: section.verifiedExperienceYears == "" ? null : section.verifiedExperienceYears,
                                verifiedExperienceMonths: section.verifiedExperienceMonths == "" ? null : section.verifiedExperienceMonths,
                            }))
                        }
                        summarySheetService.updateEntireExamModel(dataToTransmit).then(() => {
                            Swal.close();
                            props.setDownloadSummarySheet(props.downloadSummarySheet + 1);
                        });
                    }
                    else {
                        Swal.close();
                        props.setDownloadSummarySheet(props.downloadSummarySheet + 1);
                    }
                },
                allowOutsideClick: false
            })
        }
    }, [props.downloadSummarySheet])

    useEffect(() => {
        //same as above but with the combo instead of summary sheet
        if (props.downloadCombo != 0 && props.downloadCombo % 2 == 1) {
            Swal.fire({
                title: 'Saving Summary',
                didOpen: () => {
                    Swal.showLoading();
                    if (model) {
                        var dataToTransmit = {
                            ...model,
                            sections: model.sections.map(section => ({
                                ...section,
                                verifiedExperienceYears: section.verifiedExperienceYears == "" ? null : section.verifiedExperienceYears,
                                verifiedExperienceMonths: section.verifiedExperienceMonths == "" ? null : section.verifiedExperienceMonths,
                            }))
                        }
                        summarySheetService.updateEntireExamModel(dataToTransmit).then(() => {
                            Swal.close();
                            props.setDownloadCombo(props.downloadCombo + 1);
                        });
                    }
                    else {
                        Swal.close();
                        props.setDownloadCombo(props.downloadCombo + 1);
                    }
                },
                allowOutsideClick: false
            })
        }
    }, [props.downloadCombo])

    const collapseAllSections = () => {
        setCollapseSections(collapseSections + 1)
    }
    const expandAllSections = () => {
        setExpandSections(expandSections + 1)
    }


    let summaryDropDown =
        <DropdownButton as={ButtonGroup} variant='primary' title="Select Summary">
            {
                summaryTypes.map((item, i) => {

                    return (<Dropdown.Item value={item.id} key={item.id} onClick={x => {
                        setHasLoaded(false);
                        setSheetTypeId(item.id);
                        setSheetName(item.code);
                        summarySheetService.getSummarySheet(props.parentId, props.parentTypeId, item.id, props.entityId).then((response) => {
                            var data = response?.sections?.map((val, i) => {
                                return { ...val, entityId: props.entityId }
                            })
                            setModel({ ...response, sections: data })
                            setHasLoaded(true);
                        })
                    }}> {item.code}</Dropdown.Item>)
                })
            }
        </DropdownButton>;

    let renderSections =
        <>
            {model?.sections?.map((val, i) => {
                const isCompleteChecked = (isComplete) => {
                    var sections = model.sections;
                    sections[i] = { ...sections[i], isComplete: isComplete, entityId: props.entityId }
                    setModel({ ...model, sections: sections })
                    summarySheetService.updateSection(model.sections[i]).then((response) => {
                        if (response.data)
                            Swal.fire({
                                position: "top-end",
                                icon: "success",
                                toast: true,
                                showConfirmButton: false,
                                html: "<h4>&nbsp;Section Successfully Saved</h4>",
                                timer: 2000
                            });

                    })
                }
                return (<Form readOnly={!props.isUserEditable} fluid formValue={val} onChange={formValue => {
                    var sections = model.sections;
                    sections[i] = formValue
                    setModel({ ...model, sections: sections })
                }}>
                    {val &&
                        <GenericSection
                            isUserEditable={props.isUserEditable}
                            entityId={props.entityId}
                            collapseSections={collapseSections}
                            expandSections={expandSections}
                            isComplete={val?.isComplete}
                            isCompleteCallback={isCompleteChecked}
                            title={val.sectionType}
                            sectionTypeId={val.sectionTypeId}
                            summaryTypeId={sheetTypeId}
                            appTypeId={props.appTypeId}
                            parentTypeId={props.parentTypeId}
                        />
                    }
                </Form>)
            })}
        </>

    return (
        <>
            {
                hasLoaded
                    ?
                    <>
                        {model ?
                            <>
                                <Row style={{ position: 'sticky', top: '10px', zIndex: '1000' }}>
                                    <Col>
                                        {props.isUserEditable && summaryDropDown}
                                    </Col>
                                    <Col style={{ textAlign: 'right' }} >
                                        <Button className="mr-2" onClick={collapseAllSections}>Collapse All</Button>

                                        <Button onClick={expandAllSections}>Expand All</Button>
                                    </Col>
                                </Row>
                                <h4> <center>
                                    {sheetName} Worksheet/Summary Sheet</center>
                                </h4 >
                                <br />
                                <Form readOnly={!props.isUserEditable} formValue={model} fluid onChange={formValue => setModel(formValue)} >
                                    <Row className="mb-3">
                                        <Col>
                                            <FormGroup>
                                                <ControlLabel>
                                                    <strong>
                                                        Applicant's Name:
                                                    </strong>
                                                </ControlLabel>
                                                <FormControl name="applicantName" />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <ControlLabel>
                                                    <strong>
                                                        Date Received:
                                                    </strong>
                                                </ControlLabel>
                                                <FormControl type="date" name="dateReceived" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col>
                                            <FormGroup>
                                                <ControlLabel>
                                                    <strong>
                                                        MyNCEES#:
                                                    </strong>
                                                </ControlLabel>
                                                <FormControl
                                                    accepter={PhoneNumberMask}
                                                    name="myNCEES"
                                                    format="##-###-##"
                                                    mask="_"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <ControlLabel>
                                                    <strong>
                                                        Date Completed:
                                                    </strong>
                                                </ControlLabel>
                                                <FormControl type="date" name="dateCompleted" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col>
                                            <FormGroup>
                                                <ControlLabel>
                                                    <strong>
                                                        Processed By:
                                                    </strong>
                                                </ControlLabel>
                                                <FormControl name="processedBy" />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <ControlLabel>
                                                    <strong>
                                                        Date Sent for Review:
                                                    </strong>
                                                </ControlLabel>
                                                <FormControl type="date" name="dateSentForReview" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                                {renderSections}
                                <Form readOnly={!props.isUserEditable} formValue={model} fluid onChange={formValue => setModel(formValue)}>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <ControlLabel>
                                                    <strong>
                                                        Other Notes & Comments:
                                                    </strong>
                                                </ControlLabel>
                                                <FormControl
                                                    type={Input}
                                                    componentClass="textarea"
                                                    rows={5}
                                                    name="otherComments"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </> : <>{summaryDropDown}</>
                        }
                    </>
                    : <LoadingSpinner />
            }
        </>
    )
}

export default BaseSummarySheet;